<!-- org-parking-list.component.html -->
<div class="parking-container">
  <div class="header">
    <h2>Parking Locations</h2>
    <!-- <button mat-raised-button color="primary" (click)="addParking()">
    <mat-icon>add</mat-icon> Add Parking
  </button> -->
</div>

<div class="parking-grid">
  @for (parking of parkingVMs; track parking) {
    <mat-card class="parking-card">
      <mat-card-header class="parking-header">
        <mat-card-title class="parking-title">
          <mat-icon class="parking-icon">local_parking</mat-icon>
          {{ parking.parkingName }}
          @if (parking.active === false) {
            <span class="inactive-label">(inactive)</span>
          }
        </mat-card-title>
        <!-- <mat-card-subtitle>
        <span class="organization-id">ID: {{ parking.organizationId }}</span>
      </mat-card-subtitle> -->
    </mat-card-header>
    <mat-card-content>
      @if (parking.parkingDescription) {
        <p class="description">
          {{ parking.parkingDescription | translateAttribute }}
        </p>
      }
      @if (!parking.parkingDescription) {
        <p class="no-description">
          No description available
        </p>
      }
      @if (parking.parkingFeatures?.length) {
        <div class="features">
          <h4>Features:</h4>
          <ul class="features-list">
            @for (feature of parking.parkingFeatures; track feature) {
              <li class="feature-item">
                <mat-icon class="feature-icon">check_circle</mat-icon>
                <span class="feature-text">{{ feature | translateAttribute }}</span>
              </li>
            }
          </ul>
        </div>
      }
    </mat-card-content>
    <mat-card-actions align="end">
      <button mat-button color="primary" (click)="editParking(parking)">
        <mat-icon>edit</mat-icon> Edit
      </button>
      <!-- <button mat-button color="warn" (click)="deleteParking(parking)">
      <mat-icon>delete</mat-icon> Delete
    </button> -->
  </mat-card-actions>
</mat-card>
}

@if (!parkingVMs?.length || parkingVMs?.length === 0) {
  <div class="no-parkings">
    <mat-icon>local_parking</mat-icon>
    <p>No Parking Areas found</p>
    <!-- <p class="hint">You can add parking locations in the organization settings</p> -->
    <!-- <button mat-raised-button color="primary" (click)="addParking()">
    Add Your First Parking
  </button> -->
</div>
}
</div>
</div>
